module.exports = __webpack_public_path__ + "img/85.06fae74e.jpg";